import styled from 'styled-components'
import { Colors, Spacing } from 'cio-design-library/design-tokens'
import Typography, { FontWeights } from 'builder/styles/typography'

export const Container = styled.div`
  display: flex;
  flex-flow: column;
  border-radius: ${Spacing.S};
  padding: ${Spacing.L} ${Spacing.L} ${Spacing.XL};
  gap: ${Spacing.S};
  background-color: ${Colors.Indigo10};
  align-items: center;
`

export const Body = styled.div`
  max-width: 544px;
  display: flex;
  flex-flow: column;
  gap: ${Spacing.XS};
  text-align: center;
  align-items: center;
`

export const Image = styled.img`
  height: 140px;
`

export const Title = styled.div`
  ${Typography.Subhead};
  ${FontWeights.DemiBold};
  color: ${Colors.Neutral100};
`

export const Description = styled.div`
  color: ${Colors.Neutral60};
`
